






import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import {colors} from '../config';
import KeyValue from '@/utils/KeyValue';

More(Highcharts);

@Component({components: {Chart}})
export default class CompassCompetitorsNew extends Vue {
  @Prop() readonly rankings!: any[];
  @Prop() readonly overview!: any[];
  @Prop() readonly showBransch!: boolean;
  @Prop({default: true}) readonly showLabels!: boolean;

  component: any = undefined;
  hovered: number | null = null;

  chartOptions: any = {
    chart: {
      polar: true,
      type: 'area',
      height: '75%',
      backgroundColor: 'transparent',
      events: {
        click: this.onClick,
      },
    },

    credits: {
      enabled: false,
    },

    title: null,

    pane: {
//      size: '80%',
    },

    xAxis: {
      // tslint:disable-next-line:max-line-length
      categories: ['<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Avkastning') + '</span>', Vue.prototype.$t('Rörelsemarginal'), Vue.prototype.$t('Tillväxt'), '<span  style="font-weight: 600; color: black;">' + Vue.prototype.$t('Framtidsutsikter') + '</span>', Vue.prototype.$t('Soliditet'), Vue.prototype.$t('Rörelsekapital i % av omsättning'), '<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Finansiell styrka') + '</span>', Vue.prototype.$t('Kassalikviditet'), Vue.prototype.$t('Räntetäckningsgrad'), '<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Kortsiktig beredskap') + '</span>', Vue.prototype.$t('Riskbuffert'), Vue.prototype.$t('Räntabilitet på eget kapital')],
      tickmarkPlacement: 'on',
      lineWidth: 0,
      plotLines: [
        {
          color: colors.Black,
          width: 1.5,
          zIndex: 1,
          value: 0,
        },
        {
          color: colors.Black,
          width: 1.5,
          zIndex: 1,
          value: 3,
        },
        {
          color: colors.Black,
          width: 1.5,
          zIndex: 1,
          value: 6,
        },
        {
          color: colors.Black,
          width: 1.5,
          zIndex: 1,
          value: 9,
        },
      ],
      labels: {
        enabled: true,
        style: {
          fontSize: '1rem',
        },
        distance: 25,
      },
    },

    yAxis: {
      gridLineInterpolation: 'polygon',
      gridLineDashStyle: 'longdash',
      gridLineColor: colors.LightGrey,
      lineWidth: 0,
      min: 0,
      max: 100,
      tickInterval: 10,
      labels: {
        enabled: false,
      },
    },

    tooltip: {
      shared: true,
      useHTML: true,
      positioner: () => {
        return {
          x: -100000,
          y: -100000,
        };
      },
    },

    legend: {
      reversed: true,
      enabled: true,
      floating: false,
      borderWidth: 1,
      borderColor: colors.LightGrey,
      borderRadius: '0.2rem',
      padding: 16,
      backgroundColor: colors.Light,
      align: 'center',
      verticalAlign: 'bottom',
      x: 0,
      y: 0,
      layout: 'horizontal',
      itemStyle: {
        font: '1rem Assistant, Verdana, sans-serif',
      },
    },

    plotOptions: {
      series: {
        animation: true,
        fillOpacity: 0.5,
        marker: {
          radius: 0,
          states: {
            hover: {
              radius: 5,
            },
          },
          symbol: 'circle',
        },
        lineWidth: 1,
        pointPlacement: 'on',
        point: {
          events: {
            mouseOver: this.onMouseOver,
            click: this.onClick,
          },
        },
        events: {
          mouseOut: this.onMouseOut,
        },
      },
    },

    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },

    series: [],
  };

  mounted() {
    if (this.rankings === undefined) {
      return;
    }
    this.chartOptions.series = [];
    for (let i = 0; i < this.rankings.length; i++) {
      const ranking = this.rankings[i];
      this.chartOptions.series.unshift({
        name: this.overview[i].NAME,
        data: this.rankingValues(i),
        color: [colors.Primary, colors.Secondary, colors.Tertiary][i],
        lineColor: [colors.Primary, colors.Secondary, colors.Tertiary][i],
      });
    }
    const br = this.rankings[0].sheets[0].industryRanks;
    if (this.showBransch && br.score !== 0) {
      this.chartOptions.series.unshift({
        name: Vue.prototype.$t('Branschmedian'),
        data: [
          br.yield, br.operatingMargin, br.growth, br.longTerm,
          br.solidity, br.workingCapitalPct, br.financialStrength, br.quickRatio,
          br.interestCoverage, br.shortTerm, br.riskBuffer, br.returnOnCapital,
        ],
        color: colors.DarkGrey,
        lineColor: colors.DarkGrey,
        fillColor: 'rgba(0, 0, 0, 0.0)',
        lineWidth: 2,
        dashStyle: 'longDash',
        visible: true,
      });
    }
  }

  rankingValues(i: number) {
    if (!this.rankings[i].sheets) {
      return [];
    }
    const r = this.rankings[i].sheets[0].ranks;
    return [
      this.withLabel(r.yield),
      r.operatingMargin,
      r.growth,
      this.withLabel(r.longTerm),
      r.solidity,
      r.workingCapitalPct,
      this.withLabel(r.financialStrength),
      r.quickRatio,
      r.interestCoverage,
      this.withLabel(r.shortTerm),
      r.riskBuffer,
      r.returnOnCapital,
    ];
  }

  withLabel(v: any) {
    if (!this.showLabels) {
      return v;
    }
    return {
      dataLabels: {
        enabled: true,
        align: 'center',
        backgroundColor: colors.Primary,
        color: colors.White,
        allowOverlap: true,
        style: {
          textOutline: false,
          fontSize: '1rem',
          fontWeight: 'bold',
        },
        verticalAlign: 'middle',
      },
      y: v,
    };
  }

  created() {
    this.component = this;
  }

  onMouseOver(e: any) {
    this.hovered = e.target.index;
    this.component.$emit('hover', KeyValue.ByIndex(this.hovered as number));
  }

  onMouseOut() {
    this.hovered = null;
    this.component.$emit('hover', null);
  }

  onClick(e: any) {
    if (!this.hovered || this.hovered % 3 === 0) {
      return;
    }
    this.component.$emit('clicked');
  }

  get cursor() {
    if (!this.hovered || this.hovered % 3 === 0) {
      return 'default';
    } else {
      return 'pointer';
    }
  }
}


